export default {
	title: 'Wave Definition',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete {count} selected record(s)?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select the record to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		label: 'Label',
		value: 'Value Code',
		placeholder: {
			label: 'Please enter label',
			value: 'Please enter value code'
		}
	},
	table: {
		id: 'ID',
		label: 'Label',
		value: 'Value Code',
		unit: 'Unit',
		sort: 'Sort'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	widgetForm: {
		label: 'Label',
		value: 'Value Code',
		unit: 'Unit',
		sort: 'Sort',
		remark: 'Remark',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			label: 'Please enter label',
			value: 'Please enter value code',
			unit: 'Please enter unit',
			remark: 'Please enter remark'
		}
	}
}
